var _g, _g2, _g3, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 437,
    height: 472,
    viewBox: "0 0 437 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_874_451)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 218.557,
    cy: 218.562,
    r: 97.5048,
    transform: "rotate(-11.0425 218.557 218.562)",
    fill: "url(#paint0_linear_874_451)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_874_451)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.162,
    y: 220.3,
    width: 93.6998,
    height: 132.94,
    transform: "rotate(-11.0425 171.162 220.3)",
    fill: "url(#paint1_linear_874_451)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iii_874_451)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.629,
    cy: 211.371,
    rx: 81.5035,
    ry: 81.5035,
    transform: "rotate(-0.797041 231.629 211.371)",
    fill: "url(#paint2_linear_874_451)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.455 222.979C249.302 214.651 244.705 211.298 235.051 209.114C228.166 207.452 226.963 205.406 227.302 202.075C227.641 198.743 230.186 196.838 234.841 197.312C239.03 197.738 241.212 199.402 242.013 203.09C242.173 203.828 242.823 204.374 243.521 204.445L247.244 204.824C248.175 204.919 248.946 204.276 249.043 203.325L249.067 203.086C248.668 197.756 244.891 193.285 239.586 192.265L240.167 186.554C240.264 185.602 239.639 184.817 238.499 184.46L235.008 184.105C234.077 184.011 233.306 184.653 232.952 185.82L232.396 191.293C225.317 191.535 220.411 195.844 219.806 201.793C219.008 209.646 223.348 213.213 233.001 215.397C239.397 217.25 241.346 218.89 240.959 222.698C240.572 226.505 237.047 228.791 232.625 228.342C226.574 227.726 224.746 224.895 224.41 221.255C224.275 220.28 223.625 219.732 222.927 219.661L218.97 219.259C218.04 219.164 217.269 219.807 217.172 220.759L217.148 220.997C217.473 227.041 220.761 231.703 228.321 233.674L227.74 239.385C227.643 240.337 228.269 241.122 229.408 241.478L232.899 241.833C233.83 241.928 234.601 241.285 234.955 240.119L235.535 234.408C242.638 233.928 247.801 229.404 248.455 222.979V222.979Z",
    fill: "white",
    fillOpacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.07 181.823C266.076 191.235 272.137 213.232 262.613 230.394C257.607 239.784 248.806 246.166 238.779 248.243C237.781 248.572 237.209 249.21 237.026 250.392L236.513 253.701C236.366 254.647 236.719 255.427 237.607 255.807C237.838 255.843 238.301 255.914 238.568 255.714C261.629 252.026 277.349 230.015 273.893 206.485C271.783 192.604 263.417 180.9 251.13 174.639C250.279 174.023 249.281 174.353 248.903 175.262C248.635 175.463 248.599 175.699 248.526 176.172L248.013 179.481C247.903 180.19 248.45 181.243 249.07 181.823ZM213.139 251.774C213.991 252.39 214.989 252.06 215.366 251.151C215.634 250.95 215.671 250.714 215.744 250.241L216.257 246.932C216.403 245.986 215.856 244.934 215.236 244.353C198.23 234.941 192.169 212.944 201.693 195.782C206.699 186.392 215.5 180.01 225.527 177.933C226.525 177.604 227.097 176.967 227.28 175.784L227.793 172.475C227.94 171.53 227.587 170.749 226.699 170.37C226.468 170.334 226.005 170.262 225.738 170.462C202.677 174.151 186.957 196.162 190.413 219.691C192.487 233.809 201.084 245.549 213.139 251.774V251.774Z",
    fill: "white",
    fillOpacity: 0.84
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_874_451",
    x: 0.701836,
    y: 0.707695,
    width: 435.709,
    height: 435.709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.1658,
    result: "effect1_foregroundBlur_874_451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_874_451",
    x: 50.83,
    y: 82.0214,
    width: 358.091,
    height: 389.089,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60.1658,
    result: "effect1_foregroundBlur_874_451"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iii_874_451",
    x: 130.547,
    y: 101.897,
    width: 182.586,
    height: 202.166,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -19.5792,
    dy: -27.9702
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.3813
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.676044 0 0 0 0 0.235556 0 0 0 0 0.883333 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_874_451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.1881
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.1767
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7625 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_874_451",
    result: "effect2_innerShadow_874_451"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.706
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_874_451",
    result: "effect3_innerShadow_874_451"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_874_451",
    x1: 218.557,
    y1: 121.058,
    x2: 218.557,
    y2: 316.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3479F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A69EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_874_451",
    x1: 218.011,
    y1: 220.3,
    x2: 218.011,
    y2: 353.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0505",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBFBF",
    stopOpacity: 0.19
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_874_451",
    x1: 155.675,
    y1: 179.81,
    x2: 251.745,
    y2: 220.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF9AD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0085FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStable);
export default __webpack_public_path__ + "static/media/stable.430d06081ab75fd52361106f70e21c0a.svg";
export { ForwardRef as ReactComponent };